import { compose } from 'recompose';
import { connect } from 'react-redux';
import StageWarning from './component';

import { getStopStatusLog } from 'redux/modules/journeys/stop-status-log';
import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

import withStyles from './styled';

const stopFields = [
  'score',
  'stop_type',
  'status',
  'time_to',
  'delayed_datetime',
  'shipment_state_logs',
  'problems',
];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { stage, selectors, journeyId, stopId } = props;

    const stop = selectors.getJourneyStopFields(state, journeyId, stopId, stopFields);

    const { score, stop_type, time_to, delayed_datetime, shipment_state_logs, problems } =
      stop || {};

    const { warning, possibleWarning } =
      getStopStatusLog(stage, {
        problems,
        score,
        shipment_state_logs,
        stop_type,
      }) || {};

    return {
      warning,
      possibleWarning,
      stopTimeTo: time_to,
      delayedDateTime: delayed_datetime,
    };
  }),
  withStyles
);

export default enhance(StageWarning);
